/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import Pagination from './Pagination'
import StripeApiKey from './StripeApiKey'

/**
 * The InlineResponse20021 model module.
 * @module model/InlineResponse20021
 * @version 1.0.0
 */
export default class InlineResponse20021 {
  /**
   * Constructs a new <code>InlineResponse20021</code>.
   * @alias module:model/InlineResponse20021
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>InlineResponse20021</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20021} obj Optional instance to populate.
   * @return {module:model/InlineResponse20021} The populated <code>InlineResponse20021</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20021()

      if (data.hasOwnProperty('stripe_api_keys')) {
        obj['stripe_api_keys'] = ApiClient.convertToType(data['stripe_api_keys'], [StripeApiKey])
      }
      if (data.hasOwnProperty('pagination')) {
        obj['pagination'] = Pagination.constructFromObject(data['pagination'])
      }
    }
    return obj
  }

  /**
   * @member {Array.<module:model/StripeApiKey>} stripe_api_keys
   */
  stripe_api_keys = undefined
  /**
   * @member {module:model/Pagination} pagination
   */
  pagination = undefined
}
